import { render, staticRenderFns } from "./SkroutzLastMileWidget.vue?vue&type=template&id=6a7379d4"
import script from "./SkroutzLastMileWidget.vue?vue&type=script&lang=js"
export * from "./SkroutzLastMileWidget.vue?vue&type=script&lang=js"
import style0 from "./SkroutzLastMileWidget.vue?vue&type=style&index=0&id=6a7379d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports